import { CurrentOfferCost, ResiliationFormulaState } from '../types';
import { computeRemainingMonths } from './utils';

export default function computeCurrentOfferCost(state: ResiliationFormulaState): CurrentOfferCost | undefined {
  if (
    (state.promotionDuration === undefined)
    || (state.normalPrice === undefined)
    || (state.commitmentDuration === undefined)
  ) return undefined;

  const costDuration = computeRemainingMonths(state.commitmentDuration, state.startDate) || 12;
  const promoDuration = computeRemainingMonths(state.promotionDuration, state.startDate);

  const leftOverMonths = computeRemainingMonths(state.commitmentDuration, state.startDate);

  if (!promoDuration || promoDuration < 0) {
    return {
      normal: {
        months: costDuration,
        monthly: state.normalPrice,
        total: costDuration * state.normalPrice,
      },
      total: costDuration * state.normalPrice,
      commitmentLeft: leftOverMonths ?? 0,
    };
  }

  if (promoDuration) {
    if (state.promotionPrice === undefined) return undefined;
    const promoCost = {
      total: promoDuration * state.promotionPrice,
      monthly: state.promotionPrice,
      months: promoDuration,
    };

    const normalCost = {
      months: costDuration - promoDuration,
      monthly: state.normalPrice,
      total: Math.max(0, costDuration - promoDuration) * state.normalPrice,
    };

    return {
      normal: normalCost.months === 0 ? undefined : normalCost,
      promo: promoCost,
      total: promoCost.total + normalCost.total,
      commitmentLeft: leftOverMonths ?? 0,
    };
  }

  throw new Error('Not implemented');
}
